<template>
  <div id="app" ref="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.$refs.app.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  box-sizing: border-box;
  background: #212429;
  min-height: 100vh;
  min-width: 1380px;
}
body{
  min-width: 1024px;
  word-break: break-word;
}
body, p, ul, h1, h2, h3, h4, h5, h6{
  margin: 0;
  padding: 0;
  font-weight: normal;
  word-break: break-word;
}
li{
  list-style-type: none
}
.clear:after{
  content: '';
  width: 0;
  height: 0;
  display: block;
  clear: both;
}
.slt-wrp .el-input__inner{
  background: none;
  border: none;
  color: #fff;
  border-bottom: 2px solid #fff;
  border-radius: 0;
  font-size: 16px;
  padding: 0;
}
.slt-wrp .el-select .el-input .el-select__caret{
  color: #fff;
}
.el-select-dropdown__item, .el-select-dropdown__item.selected{
  color: #606266;
}
.input-item .el-input__inner{
  background: none;
  border: none;
  border-radius: 0;
  padding: 0;
  border-bottom: 1px solid #fff;
  font-size: 16px;
  color: #fff;
}
.el-table__body {
  width: 100%;
  table-layout: fixed !important;
}
.el-table__body-wrapper {
  width: 100%;
  table-layout: fixed !important;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
table {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue